export default class {
  constructor(params = {}) {
    let defaultValue = this.constructor.defaultValue()
    defaultValue['i'] = this.constructor.uuid++
    for (let key of Object.keys(defaultValue)) {
      this[key] = defaultValue[key]
    }
    for (let key of Object.keys(params)) {
      if (key == "i" && params[key] == null ) continue
      this[key] = params[key]
    }
  }

  static initialize(object){
    this.agencies = object.agencies
    this.sales_people = object.sales_people
    return true
  }

  static defaultValue() {
    if (this.uuid == undefined) {
      this.uuid = 0
    }
    return {
      id: null,
      isbn: null,
      agency_code: null,
      agency_shop_code: null,
      bansen: null,
      bibo: null,
      shop_person: null,
      sales_person_id: null,
      shop_code: null,
      created_at: null,
      processed_at: null,
      final_book_shop_name: null,
      zip_code: null,
      main_address: null,
      sub_address: null,
      _destroy: null,
      checked: false
    }
  }

  static importCsvArray(array, i) {
    let d = this.defaultValue()
    d.i = i
    d.isbn = `${array[0]}`
    const agency = this.agencies.find(agency => agency.name == array[1] || agency.code == array[1])
    if(agency)
      d.agency_code = `${agency.code}`
    d.agency_shop_code = `${array[2]}`
    d.bansen = array[3]
    d.bibo = array[4]
    d.shop_person = array[5]
    const sales_person = this.sales_people.find(item => item.name == array[6] || item.id == array[6])
    if(sales_person)
      d.sales_person_id = sales_person.id

    return new this(d)
  }
}
